export const envs = {
  devEnvironment: process.env.REACT_APP_DEVELOPMENT === 'TRUE' ? true : false,
};
